// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"28d5e963","116":"c11c9e0a","191":"296fe13b","374":"7310aacf","584":"915016e1","659":"32b6f158","730":"961d1453","737":"b2a223ef","912":"13e6980b"}[chunkId] + ".chunk.js";
};